import { onApiResponse, onSignOut } from "@wirevod/app-core";
import { useSyncExternalStore } from "react";

/**
 * Whether WireVoD staff have suspended the signed-in workspace. Set when any
 * API call answers `403 tenant_suspended` (or `/v1/auth/me` reports it), and
 * read by the app shell to replace the product with a clear notice.
 */
let suspended = false;
const listeners = new Set<() => void>();

export function isSuspended(): boolean {
  return suspended;
}

export function setSuspended(value: boolean): void {
  if (suspended === value) return;
  suspended = value;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useSuspended(): boolean {
  return useSyncExternalStore(subscribe, isSuspended, isSuspended);
}

/** Notices `403 tenant_suspended` on any API response; clears on sign-out. */
export function watchSuspension(): void {
  onApiResponse(async (response) => {
    if (response.status !== 403) return;
    const body = (await response
      .clone()
      .json()
      .catch(() => null)) as { code?: unknown } | null;
    if (body?.code === "tenant_suspended") setSuspended(true);
  });
  onSignOut(() => setSuspended(false));
}
